export default {
	//baseUrl: 'http://localhost:8012',
	baseUrl: 'https://reg.suanliai.cn',
	pageTitle: '信息收集',
		
	routes: [],
	verifyImgs: [], //拼图验证码缓存
	share: {}, //分享信息
	
	options: {
		H5: {
			domainName: 'http://localhost:8001', //h5端访问域名
			notLoadJssdkPaths: [
				'IndexLogin', 'Index404'
			],
			loadJssdk: true, //在微信浏览器端，是否要加载jssdk配置参数
		}
	},
	verifyImgs: [], //拼图验证码缓存
	
}